import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ReportsServiceProvider } from '../../api/reports'

const ReportsService = ReportsServiceProvider()
const name = 'getBulkReports'

export default () => (asyncAction(
  name,
  ReportsService.getBulkReports,
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/reports/getBulkReports.js